/**
 * © 2026 iTech India Private Limited. All rights reserved.
 * Licensed under the iTech End User License Agreement (EULA).
 * Unauthorized use or distribution is prohibited.
 */

import { z } from 'zod';

/** Home-task category chips — mirrors the API `home_task_category` enum. */
export const HOME_TASK_CATEGORIES = [
  'social',
  'sensory',
  'cognitive',
  'communication',
  'motor',
  'other',
] as const;

/** How often a task recurs — mirrors the API `home_task_frequency` enum. */
export const HOME_TASK_FREQUENCIES = ['daily', 'weekly'] as const;

/** Per-day outcome — mirrors the API `home_completion_status` enum. */
export const COMPLETION_STATUSES = ['done', 'partial', 'skipped'] as const;

/** Assign a home task (Figma therapist "Assign Home Task"). Mirrors `CreateHomeTaskDto`. */
export const CreateHomeTaskSchema = z.object({
  clientId: z.string().uuid('Select a client'),
  title: z.string().trim().min(1, 'Enter a task').max(200),
  category: z.enum(HOME_TASK_CATEGORIES),
  frequency: z.enum(HOME_TASK_FREQUENCIES).optional(),
  instructions: z.string().trim().max(1000).optional(),
  goalId: z.string().uuid().optional(),
});
export type CreateHomeTaskInput = z.infer<typeof CreateHomeTaskSchema>;

/** Mark a task's daily outcome (Figma round check). Mirrors `MarkCompletionDto`. */
export const MarkCompletionSchema = z.object({
  status: z.enum(COMPLETION_STATUSES),
  note: z.string().trim().max(500).optional(),
});
export type MarkCompletionInput = z.infer<typeof MarkCompletionSchema>;
